import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SideBar from "../../../../components/SideBar";
import Navbar from "../../../../components/Navbar";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { hrinterviews } from "../../../../api/Api";
import DataTable, { defaultThemes } from "react-data-table-component";
import moment from "moment";
import { API_URL } from "../../../../constants/index";
import Select from "react-select";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
function HRInterviews() {
  const navigate = useNavigate();
  const [pending, setPending] = React.useState(true);
  const [showDropDown, setShowDropDown] = React.useState(false);
  const [filterText, setFilterText] = React.useState("");
  const [filterFormData, setFilterData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [applicant, setApplicant] = useState([]);
  const [jobTitleOpts, setJobTitleOpts] = React.useState([]);
  const [statusOpts, setStatusOpts] = React.useState([]);
  const [hrOpts, setHrOpts] = React.useState([]);
  const [sourceOpts, setSourceOpts] = React.useState([]);
  const [skillsOpts, setSkills] = React.useState([]);
  const [respStatus,setRepStatus]= useState(0);
   const [apiStatus, SetApiStatus] = useState(undefined);
  const [hideNameDirector, setHideDirector] = React.useState({
    FullName: false,
    JobTitle: false,
    CandidateReferralType: false,
    ReferralName: false,
    LeadCandidateStatus: false,
    RecruiterName: false,
    AppliedDate: false,
    IsInActive: false,
  });
  const columns = {
    FullName: { text: "Name", visible: true },
    JobTitle: { text: "Job Title", visible: true },
    CandidateReferralType: { text: "Referral Type", visible: true },
    ReferralName: { text: "Referral Name", align: "start", visible: true },
    LeadCandidateStatus: { text: "Status", visible: true },
    RecruiterName: { text: "HR Name", visible: true },
    AppliedDate: { text: "Applied Date", align: "center", visible: true },
    // IsInActive: { text: "Active", align: "center", visible: true },
  };
  const defaultColumns = {
    FullName: true,
    JobTitle: true,
    CandidateReferralType: true,
    ReferralName: true,
    LeadCandidateStatus: true,
    RecruiterName: true,
    AppliedDate: true,
    // IsInActive: true,
  };

  const formDatas = [
    { name: "Job Title", type: "Select", options: [...jobTitleOpts] },
    { name: "Status", type: "Select", options: [...statusOpts] },
    { name: "HR Name", type: "Select", options: [...hrOpts] },
    // { name: "Source", type: "Select", options: [...sourceOpts] },
    // { name: "Skill Sets", type: "Select", options: [...skillsOpts] },
    { name: "Candidate Name", type: "Text" },
    // {name:"To",type: "Date",},
    // {name:"Text",type: "Text",},
    // {name:"Position",type: "Text",},
  ];

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Free Pull"))
  }, [])

  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);

  const setColumnHider = () => {
    setShowDropDown(!showDropDown);
  };

  const [formData, setFormData] = useState({
    JobTitle: "",
    Status: "",
    RecruiterName: "",
    FullName: "",
    source: "",
    skill: "",
  });

  useEffect(() => {
    fetchDetails();
  }, []);

  const handleEdit = (state) => {
    navigate("/hrinterviews/new-application/edit/" + state.ID);
  };
  const handleCreate = (state) => {
    window.location.href = "/add-candidate/" + state.ID;
  };

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
        textAlign: "center",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: defaultThemes.default.divider.default,
        textAlign: "center",
        justifyContent: "center",
        backgroundColor: "#FFA500",
      },
    },
    rows: {
      style: {
        backgroundColor: "#FFFFFF",
        "&:nth-child(2n)": {
          backgroundColor: "#EEEEEE",
        },
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
          textAlign: "center",
        },
      },
    },
    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
          textAlign: "center",
        },
      },
    },
  };
  const filteredItems = applicant.filter(
    (item) =>
      item.FullName &&
      item.FullName.toLowerCase().includes(filterText.toLowerCase())
  );
  const [check, setCheck] = useState();

  const fetchDetails = async (overrideFilters) => {
    try {
      const activeFilters = overrideFilters || filterFormData;
      //calling API for the data
      let jd = formData.JobTitle?.value || "";
      let status = formData.Status?.value || "";
      let hr = formData.RecruiterName?.value || "";
      let source = formData.source?.value || "";
      let skill = formData.skill?.value || "";
      const response = await GetServiceCaller(
        `${API_URL}HRInterview?CandidateJobDescriptionID=${
          activeFilters.find((o) => o.label === "Job Title")
            ? activeFilters.find((o) => o.label === "Job Title").value
            : 0
        }&CandidateStatus=${
          activeFilters.find((o) => o.label === "Status")
            ? activeFilters.find((o) => o.label === "Status").value
            : 0
        }&HRName=${
          activeFilters.find((o) => o.label === "HR Name")
            ? activeFilters.find((o) => o.label === "HR Name").value
            : 0
        }&CandidateName=${activeFilters.find((o) => o.label === "Candidate Name")
          ? activeFilters.find((o) => o.label === "Candidate Name").value
          : 0}&source=${
          activeFilters.find((o) => o.label === "Source")
            ? activeFilters.find((o) => o.label === "Source").value
            : 0
        }&skill=${
          activeFilters.find((o) => o.label === "Skillsets")
            ? activeFilters.find((o) => o.label === "Skillsets").value
            : 0
        }`
      );
      SetApiStatus(response?.status);
      const data = await response?.data?.headers;      
      setApplicant(data);
      setPending(false);
      // job title option fetching
      const apidata1 = response?.data?.jobtitle?.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));;
      setJobTitleOpts(apidata1);

      // fetch status
      const apidata3 = response?.data?.status?.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));;
      setStatusOpts(apidata3);
      // fetch hr
      const apidata2 = response?.data?.hr?.original?.Hr?.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));;
      setHrOpts(apidata2);
      // fetch source
      const apidata4 = response?.data?.source?.map((tech) => ({
        value: tech.value,
        label: tech.text,
      }));;
      setSourceOpts(apidata4);
      // fetch skills
      const apidata5 = response?.data?.skills?.map((row) => ({
        value: row.ID,
        label: row.Name,
      }));;
      setSkills(apidata5);
      setRepStatus(response.status);
    } catch (error) {
      console.error("Error fetching Location:", error);
    }
  };
  // setting job title
  const jobtitleopts = jobTitleOpts?.map((tech) => ({
    value: tech.value,
    label: tech.text,
  }));
  // setCheck(jobtitleopts);

  // setting status
  const statusopts = statusOpts?.map((tech) => ({
    value: tech.value,
    label: tech.text,
  }));
  //setting hr
  const hropts = hrOpts.map((tech) => ({
    value: tech.value,
    label: tech.text,
  }));
  // setting source
  const sourceopts = sourceOpts.map((row) => ({
    value: row.value,
    label: row.text,
  }));
  // setting skills
  const skillsopts = skillsOpts.map((row) => ({
    value: row.ID,
    label: row.Name,
  }));
  const handleDropDownChange = (selected, name) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: selected,
    }));
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const exportToExcel = () => {
    let newData = [];
    for (let row of applicant) {
      let obj = {};
      var result = Object.keys(defaultColumns).map((key) => key);
      for (let key of result) {
        obj[key] = row[key];
      }
      newData.push(obj);
    }
    const header = Object.keys(newData[0]).join(",") + "\n";
    const csv = newData.map((item) => Object.values(item).join(",")).join("\n");
    const csvData = header + csv;
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "download.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleChange = (e, name) => {

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };
  const handleReset = () => {
    setFilterData([]);
    fetchDetails([]);
  };
  const handleGetData = () => {
    fetchDetails();
  };
  return (
    <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="row">
              <Dynamic_PR_table
                data={applicant}
                columns={columns}
                defaultColumns={defaultColumns}
                itemsPerPage={8}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                showIcon1={true}
                isFilterRequired={true}
                isSorting={true}
                isApiStatus={apiStatus}
                isRequiredStatus={true}
                formDatas={formDatas}
                handleChange={handleChange}
                filterFormData={filterFormData}
                handleGetData={handleGetData}
                handleReset={handleReset}
                handleIcon1={handleEdit}
                isActionRequired={true}
                add
                more
                function
                icons={{
                  Icon1: <i class="bi bi-pencil-square"></i>,
                }}
              />
            </div>
          </div>
        </div>

    </>
  );
}

export default HRInterviews;

const FilterComponent = ({ filterText, onFilter, onClear, columns }) => (
  <>
    <div className="row">
      <div className="col-sm-4">
        <label>
          <strong>Candidate Name</strong>
        </label>
      </div>
      <div className="col-sm-8">
        <input
          className="form-control"
          id="search"
          type="text"
          placeholder="Candidate By Name"
          aria-label="Search Input"
          value={filterText}
          onChange={onFilter}
        />
      </div>

      {/* <div className="input-group-text btn btn-info btn-sm" type="button" onClick={onClear}>
                    X
                </div> */}
    </div>
  </>
);
